export const styles = {
  base: 'text-nowrap align-middle',
  noData: 'text-nowrap align-middle text-center fw-medium text-secondary',
  notApplicable: 'text-nowrap align-middle bg-light bg-opacity-20 text-center fw-medium text-secondary',
  colWidth: {
    xsmall: { minWidth: '100px', maxWidth: '100px', width: '100px' },
    small: { minWidth: '130px', maxWidth: '130px', width: '130px' },
    medium: { minWidth: '150px', maxWidth: '150px', width: '150px' },
    large: { minWidth: '170px', maxWidth: '170px', width: '170px' },
    xlarge: { minWidth: '190px', maxWidth: '190px', width: '190px' },
    full: { width: '100%' },
  },
  highlightHeader: {
    borderWidth: 'medium',
    borderBottom: 'none',
    borderColor: 'black',
  },
  highlight: {
    borderWidth: 'medium',
    borderBottom: 'none',
    borderTop: 'none',
    borderColor: 'black',
  },
};
